import { Col, Typography } from "antd";
import { Card, Row, Table } from "antd";
import React, { FC, useState } from "react";

const { Text } = Typography;

type IncentiveDetailsProps = {
  packageFinanceData: any;
  totalAmountData: any;
}

const IncentiveDetails: FC<IncentiveDetailsProps> = ({
  packageFinanceData,
  totalAmountData,
}) => {
  const FinanceColumns = [
    {
      title: "No.",
      dataIndex: "no",
      key: "no",
      render: (_: string, r_: any, index: number) => (
        <span style={{ fontWeight: "bold" }}>{index + 1}</span>
      ),
    },
    {
      title: "Package Code",
      dataIndex: "procedureCode",
      key: "procedureCode",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Package Type",
      dataIndex: "packageType",
      key: "packageType",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Procedure Cost",
      dataIndex: "procedureCost",
      key: "procedureCost",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Stratification Cost",
      dataIndex: "stratificationCost",
      key: "stratificationCost",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
      key: "quantity",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Package Cost",
      dataIndex: "packageCost",
      key: "packageCost",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Adj Factor",
      dataIndex: "adjFactor",
      key: "adjFactor",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Incentives",
      dataIndex: "incentives",
      key: "incentives",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
    {
      title: "Total",
      dataIndex: "totalAmount",
      key: "totalAmount",
      render: (text: string) => (
        <span style={{ fontWeight: "bold" }}>{text}</span>
      ),
    },
  ];

  const renderRow = (label: string, value: string) => (
    <Row justify="space-between" style={{ marginBottom: 8 }}>
      <Col>
        <Text>{label}</Text>
      </Col>
      <Col>
        <Text strong>{value}</Text>
      </Col>
    </Row>
  );

  return (
    <>
      <h3>Bill Details</h3>
      <Row gutter={[16, 16]}>
        <Table
          dataSource={packageFinanceData}
          columns={FinanceColumns}
          className="claim-table"
          pagination={false}
          bordered
          style={{
            width: "95%",
            textAlign: "center",
            paddingBottom: "15px",
          }}
        />
        {totalAmountData && (
          <div
            style={{
              width: "95%",
              margin: "10px auto",
              textAlign: "center",
              paddingBottom: "15px",
              backgroundColor: "rgb(229, 243, 243)",
            }}
          >
            {totalAmountData?.totalPackageAmount &&
              renderRow(
                "Total package amount (without incentives)",
                totalAmountData?.totalPackageAmount
              )}
            {totalAmountData?.adjustedPackageAmount &&
              renderRow(
                "Total adjusted package amount (as per guidelines)",
                totalAmountData?.adjustedPackageAmount
              )}
            {totalAmountData?.totalPayableAmount &&
              renderRow(
                "Total payable amount (after incentives)",
                totalAmountData?.totalPayableAmount
              )}
            {totalAmountData?.eRupiAmount &&
              renderRow("e-RUPI Amount", totalAmountData?.eRupiAmount)}
            {totalAmountData?.miscAmount &&
              renderRow("Miscellaneous Amount", totalAmountData?.miscAmount)}
          </div>
        )}
        </Row>
    </>
  );
};

export default IncentiveDetails;
